export const DATE_FORMAT = "DD-MM-YYYY";

export const DATETIME_FORMAT = "DD-MM-YYYY HH:mm";

export const TIME_FORMAT = "HH:mm";

export const PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_MAX_LENGTH = 50;

export const ADMIN_ROUTE_PREFIX = "admin";
export const ADMIN_MOBILE_ROUTE_PREFIX = "admin/mobile";

export const VAT_NUMBER_REGEX_PATTERN = "^[0-9]{11}$";
export const FISCAL_CODE_REGEX_PATTERN = "^([A-Za-z0-9]{16})$|([0-9]{11})$";

export const TARI_ROW_TYPE = {
   MQ_COST: "MQ_COST",
   ADDITIONAL_COST: "ADDITIONAL_COST",
   EMPTYING_COST: "EMPTYING_COST",
   PEREQUATIVE_COST: "PEREQUATIVE_COST",
};
